import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff, deduplicateRequest } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.payments_api.caja_movements;

const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Wrap with cache
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'payments_api',
  group: 'caja_movements',
  defaultTtl: '30s',
  hashLargeSegments: true,
  emitMeta: true,
});


// /GetCajaMovementsByLocal/<int:local_id>'

export const getCajaMovementsByLocal = async (localId: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetCajaMovementsByLocal/${localId}`, undefined, { ttl: '1m' })
    );
}


// Obtener movimientos de caja por usuario
export const getCajaMovementsByUserId = async (user_id: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetCajaMovementsByUserId/${user_id}`, undefined, { ttl: '1m' })
    );
}

// Obtener movimientos de caja por tipo
export const getCajaMovementsByLocalAndType = async (local_id: number, caja_movement_type_id: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetCajaMovementsByLocalAndType/${local_id}/${caja_movement_type_id}`, undefined, { ttl: '1m' })
    );
};

// Obtener movimientos de caja por rango de montos
export const getCajaMovementsByLocalAndAmountRange = async (local_id: number, start_amount: number, end_amount: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetCajaMovementsByLocalAndAmountRange/${local_id}/${start_amount}/${end_amount}`, undefined, { ttl: '1m' })
    );
};

// /GetCajaMovementsBySession/<int:session_id>

export const GetCajaMovementsBySession = async (sessionId: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetCajaMovementsBySession/${sessionId}`, undefined, { ttl: '1m' })
    );
}

// /GetCajaMovementSessionSummaryByLocalId/<int:local_id>

export const getCajaMovementSessionSummaryByLocalId = async (localId: number) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetCajaMovementSessionSummaryByLocalId/${localId}`, undefined, { ttl: '1m' })
    );
}

export const getCajaMovementsByLocalAndDateRange = async (localId: number, startDate: string, endDate: string) => {
    return await retryWithBackoff(() =>
        cachedApi.get(`/GetCajaMovementsByLocalAndDateRange/${localId}/${startDate}/${endDate}`, undefined, { ttl: '1m' })
    );
}


// /CreateCajaMovement

export const createCajaMovement = async (workstationId: number, userId: number, mtId: number, amount: number, description: string) => {
    const res = await retryWithBackoff(() =>
        api.post('/CreateCajaMovement', {
            workstation_id: workstationId,
            user_id: userId,
            movement_type_id: mtId,
            amount: amount,
            description: description
        })
    );
    await cachedApi.clear();
    return res;
}


///RegisterCashPayment

export const registerCashPayment = async (workstationId: number, userId: number, amount: number, transactionId: number, change: number, is_transference:boolean) => {
    const res = await deduplicateRequest(
        `registerCashPayment:${transactionId}`,
        () => retryWithBackoff(() =>
            api.post('/RegisterCashPayment', {
                workstation_id: workstationId,
                user_id: userId,
                amount: amount,
                transaction_id: transactionId,
                change: change,
                is_transference

            })
        )
    );
    await cachedApi.clear();
    return res;
}
